module.exports = __webpack_public_path__ + "img/win_9.16269972.png";